import { IHistoricalOrder, IServerOrder } from '@rbi-ctg/menu';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { getOrderNumber } from 'utils/order';

export default function useOrderNumber(
  serverOrder: IServerOrder | IHistoricalOrder | null | undefined
): string | null {
  const enableOrderNumberGeneration = useFlag(LaunchDarklyFlag.ENABLE_ORDER_NUMBER_GENERATION);
  if (!serverOrder) {
    return null;
  }
  return getOrderNumber(serverOrder, enableOrderNumberGeneration);
}
